import { POSTFORM, POST } from '@/utils/request.ts'

// 培训中心首页,获取培训列表（通过二级渠道）、课程-上报进度(仅视频使用) 课程-完成 公用
export const home = (params: object) => {
  return POST({
    url: '/v3/mapping/bd/train/client/scene/courier',
    data: params,
    showError: false
  })
}
// 获取培训详情信息
export const trainDetail = (params: object) => {
  return POST({
    url: '/v3/mapping/bd/train/client/core/train',
    data: params,
    showError: false
  })
}
// 课程-学习
export const study = (params: object) => {
  return POST({
    url: '/v3/mapping/bd/train/client/core/course',
    data: params,
    showError: false
  })
}
// 考试-开始、考试-获取题目、考试-回答题目、考试-结束、考试-获取错题集 公用
export const exam = (params: object) => {
  return POST({
    url: '/v3/mapping/bd/train/client/core/exam',
    data: params,
    showError: false
  })
}
// 获取课程评价状态接口/提交课程评价
export const coreCourse = (params: object) => {
  return POST({
    url: '/v3/mapping/bd/train/client/core/course',
    data: params,
    showError: false
  })
}
